/**
 * The server's password rule (Common/Auth/PasswordPolicy.cs): 8 to 64 characters, an
 * uppercase and a lowercase letter, a digit and a symbol, no spaces. The create form checked
 * 6-15 with a letter, a digit and a symbol, so passwords it accepted were refused on save.
 */
export const PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])(?!.*\s).{8,64}$/
